import { useTranslation } from 'react-i18next';
import { InitiateButtonRectangle } from '../../../../../../../components/initiate-button-rectangle';
import { useSetDailyMode } from '../../../../../api/gate/gate.hooks';
import { useChannelsStateStore } from '../../../../../store/channels-state';
import { ChannelGateType, ChannelGateStateType, ChannelType } from '../../../../../types';
import { useGateSupportedFeatures } from '../../hooks/use-gate-supported';

type DailyModeProps = {
  channel: ChannelType;
};

export const DailyMode: React.FC<DailyModeProps> = ({ channel }) => {
  const { t } = useTranslation('channel-details');
  const { mutate } = useSetDailyMode();
  const { dailyModeModeSupported } = useGateSupportedFeatures(channel);
  const state = useChannelsStateStore((s) => s.channelState[channel.id]) as ChannelGateStateType | null;

  const handleSetDailyMode = () => {
    mutate({
      channelId: channel.id,
      deviceId: channel.deviceId,
      value: !state?.dailyModeStatus,
    });
  };

  if (!(channel.data as ChannelGateType).isDailyModeVisible || !dailyModeModeSupported) return null;

  return (
    <InitiateButtonRectangle isOn={!!state?.dailyModeStatus} onClickControl={handleSetDailyMode} className="m-t-16">
      {t('dailyMode')}
    </InitiateButtonRectangle>
  );
};
